import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as constants from '../constants/system-setup-constants';

import type {List, MapOf} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type SsGeneralStore = {
    options: MapOf<{
        timezone: List<string>;
        locale: List<string>;
    }>;
};

// always support America/New_York and en-US
const initialState = (): SsGeneralStore => {
    return {
        options: Immutable.Map({
            timezone: Immutable.List(['America/New_York']),
            locale: Immutable.List(['en-US']),
        }),
    };
};

const actionsMap: ActionsMap<SsGeneralStore> = {
    [constants.TIMEZONES_SUCCESS]: (state, action) => {
        const timezones = action.data
            .map((tz) => {
                return tz.get('name');
            })
            .sort();

        return {
            options: state.options.merge(
                Immutable.Map({
                    timezone: timezones,
                }),
            ) as SsGeneralStore['options'],
        };
    },
    [constants.LOCALES_SUCCESS]: (state, action) => {
        return {
            options: state.options.merge(
                Immutable.Map({
                    locale: action.data,
                }),
            ) as SsGeneralStore['options'],
        };
    },
    [constants.DISPOSE_SS_GENERAL_SETTINGS_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SsGeneralStore>(initialState(), actionsMap);
